import { render } from "./ReportComponentsTest.vue?vue&type=template&id=84586b56"
import script from "./ReportComponentsTest.vue?vue&type=script&lang=js"
export * from "./ReportComponentsTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__